import React from "react";
import { BrowserRouter } from "react-router-dom";

import Header from "@components/Header/Header";
import Footer from "@components/Footer/Footer";
import AppRoutes from "./routes/AppRoutes"; 
import "@styles/main.scss";
import ScrollToTop from "./components/common/ScrollToTop/ScrollToTop";

const App = () => {
  return (
    <BrowserRouter>
     <ScrollToTop />
      <div className="app">
        <Header />

        <AppRoutes />

        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
